import * as zod from 'zod';

export const EwellixLiftTLTCommand = zod.object({
  kind: zod.literal('EwellixLiftTLTCommand'),
  heightMeters: zod.number(),
  speedPercentage: zod.number().min(0).max(1),
});

export type EwellixLiftTLTCommand = zod.infer<typeof EwellixLiftTLTCommand>;
